import * as React from "react";
import type { SVGProps } from "react";
const SvgAutomaticTransmission = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 3v9H5c-.55 0-1 .45-1 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1c0 .55.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3V3c0-.55-.45-1-1-1s-1 .45-1 1M6 16h6v-2H6z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 4h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1M17 10h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1M20 16h-3c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1M17 22h3c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1"
    />
  </svg>
);
export default SvgAutomaticTransmission;
